<template>
  <div>
    <div class="page-header_header">
      <a :href="backUrl">
        <img
          src="/static/images/icons/black/back.png"
          alt="back button image"
          class="back_image_button"
        />
      </a>
      <slot name="headerContent"></slot>
    </div>
    <h2 class="page_title">
      <slot name="headerIcon"></slot>
      {{ title }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    title: {
      type: String
    },
    backUrl: {
      type: String,
      default: 'home'
    }
  }
}
</script>

<style>
.page-header_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page-header_header .header-link-button {
  font-weight: 700;
  text-transform: initial;
  color: rgba(44, 97, 213, 1);
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// page-header.vue?c8e2059a